import CustomButton from "./CustomButton";
import CustomDatePicker from "./CustomDatePicker";
import FileLoading from "./FileLoading";

const CustomComponent = {
  install(Vue) {
    Vue.component("Custom-Btn", CustomButton);
    Vue.component("Custom-DatePicker", CustomDatePicker);
    Vue.component("File-Loading", FileLoading);
  }
};

export default CustomComponent;



// WEBPACK FOOTER //
// ./src/components/CustomComponent/index.js